
import { Vue, Component, Prop } from 'vue-property-decorator'
import DashboardCustomer from '../../components/Dashboards/DashboardCustomer.vue'
  @Component({
    name: 'student',
    components: { DashboardCustomer }
  })
export default class student extends Vue {
  mounted() {}
}
